import { Link } from "react-router-dom";
import type { BreadcrumbItem } from "@/hooks/useSeo";

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={item.path} className="flex items-center gap-2">
            {isLast ? (
              <span className="text-foreground-700" aria-current="page">
                {item.name}
              </span>
            ) : (
              <Link to={item.path} className="transition-colors hover:text-primary-600">
                {item.name}
              </Link>
            )}
            {!isLast ? <i className="ri-arrow-right-s-line" aria-hidden="true" /> : null}
          </span>
        );
      })}
    </nav>
  );
}